import { MatButton } from 'components/buttons'
import { Icon } from 'hello-design-system'

const MicLightIconButton: React.FC<{
    active: boolean
    onClick: React.MouseEventHandler<HTMLButtonElement>
    alert: boolean
}> = ({ active, onClick, alert }) => (
    <MatButton
        id='mic-light-icon-button'
        onClick={onClick}
        variant='contained'
        className={`${active ? 'button-in-active' : ''}`}
        width='56px'
        height='48px'
        borderRadius='48px'
        color={alert ? 'warning' : 'primary'}
    >
        <Icon width={24} iconName={active ? 'MicRounded' : 'MicOffRounded'} />
    </MatButton>
)
export { MicLightIconButton }
